// TODO: In prod, resources would be fetched from the database.

import { Resource } from "@/types/supabase";

export const resourcesAvailable = [
  {
    name: "Perceived Lack of Control 1",
    description: "Stress and perception of control.",
    type: "article",
    link: "https://www.google.com",
    checked: false,
    stressor: "loss_of_control",
  },
  {
    name: "Work-Life Balance 1",
    description: "Stress and burnout: How to manage mental health in sales.",
    type: "article",
    link: "https://www.google.com",
    checked: false,
    stressor: "work_life_balance",
  },
];

export const resourcesLossOfControl = [
  {
    name: "Stress and the Perception of Control",
    type: "Article",
    link: "https://beuoflsbeurrfkfaahae.supabase.co/storage/v1/object/public/vincer-public-resources//Perceived%20Lack%20of%20Control%201.pdf",
  },
  {
    name: "How Can You Deal With Stress and Lack of Control?",
    type: "Article",
    link: "https://beuoflsbeurrfkfaahae.supabase.co/storage/v1/object/public/vincer-public-resources//Perceived%20Lack%20of%20Control%202.pdf",
  },
  {
    name: "3 Key Concepts to Reduce Your Stress in Uncertain Times",
    type: "Article",
    link: "https://beuoflsbeurrfkfaahae.supabase.co/storage/v1/object/public/vincer-public-resources//Perceived%20Lack%20of%20Control%203.pdf",
  },
] as Resource[];

export const resourcesWorkLifeBalance = [
  {
    name: "Stress and burnout: How to manage mental health in sales",
    type: "Article",
    link: "https://beuoflsbeurrfkfaahae.supabase.co/storage/v1/object/public/vincer-public-resources//Work-Life%20Balance%201.pdf",
  },
  {
    name: "Work-Life Balance: Managing Stress and Prioritizing Mental Health",
    type: "Article",
    link: "https://beuoflsbeurrfkfaahae.supabase.co/storage/v1/object/public/vincer-public-resources//Work-Life%20Balance%202.pdf",
  },
  {
    name: "Finding Balance Workbook",
    type: "Tool",
    link: "https://beuoflsbeurrfkfaahae.supabase.co/storage/v1/object/public/vincer-public-resources//Work-Life%20Balance%203.pdf",
  },
] as Resource[];

export const recommendResource = (stressor: string) => {
  return resourcesAvailable.filter(
    (resource) => resource.stressor === stressor
  );
};

export const resourcesShared = [
  {
    title: "SPIN Selling Framework Guide",
    type: "PDF",
    date: "Dec 8, 2024",
    description: "Comprehensive guide for discovery questioning",
  },
  {
    title: "Objection Handling Playbook",
    type: "Video",
    date: "Dec 8, 2024",
    description: "Role-play examples for common sales objections",
  },
  {
    title: "Value Proposition Canvas",
    type: "Template",
    date: "Dec 1, 2024",
    description: "Template for mapping customer value propositions",
  },
  {
    title: "Sales Script Templates",
    type: "Document",
    date: "Nov 24, 2024",
    description: "Proven conversation starters and closing techniques",
  },
];
